import {Inject, Injectable} from '@angular/core';
import { environment } from '@environments/environment';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppTenantDetail } from '@models/data/tenants/AppTenantDetail';
import { mapRes } from '@app/shared/utils/data-parsing/http/ResponseMapper.util';
import { objectToQueryParams } from '@shared/utils/data-parsing/http/ObjectToQueryParams';
import {APP_CONFIG, AppConfig} from '@src/app.config';

@Injectable({
  providedIn: 'root',
})
export class TenantHttpService {
  baseEndpoint = `${this.appConfig.angularEndpoint}/fitMedProfileTenants`;

  private endpoints = {
    getByFitMedProfileId: `${this.baseEndpoint}/byFitMedProfileId`,
  };

  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig, private httpClient: HttpClient) {}

  async getByFitMedProfileId(
    fitMedProfileId: string
  ): Promise<AppTenantDetail[]> {
    const endpoint = `${
      this.endpoints.getByFitMedProfileId
    }${objectToQueryParams({ fitMedProfileId })}`;

    return await firstValueFrom(
      this.httpClient.get(endpoint).pipe(mapRes)
    ).then((res) => res.body);
  }
}
